<template>
    <div>
        <v-alert
      v-model="alert_info"
      dismissible
      type="success"
    >
     Du Nouveau sur HIROPAY Découvrez l'échange <span style="text-decoration: underline" class="font-weight-bold">INSTANTANNÉ et sans FRAIS</span> ,  <v-btn color="red" router :to = "'/exchange' ">essayez le SWAP</v-btn>
    </v-alert>

    

    </div>
</template>

<script>
    export default {
        data() {
            return {
                alert_info:true,
            }
        },
        methods: {
            instant_dialog() {
     this.$root.$emit('activate_instant_dialog')
    }
        },
    }
</script>

<style lang="scss" scoped>

</style>